import * as React from "react";
import { observer, inject } from "mobx-react";
import { FeaturedSuppliersProps } from "./typings";
import { FeaturedSuppliers as RetailFeaturedSuppliers } from "@shared-ui/retail-landing-product";

const FeaturedSuppliers = (props: FeaturedSuppliersProps) => {
  const { uriContext: uriContextStore, context, templateComponent } = props;

  const uriContext = uriContextStore?.get();

  if (!context || !uriContext) {
    return null;
  }

  const { startDateOffset, endDateOffset, minSuppliersCount, maxSuppliersCount } = templateComponent.config || {};

  const inputs = {
    context,
    uriContext: uriContext as React.ComponentProps<typeof RetailFeaturedSuppliers>["inputs"]["uriContext"],
    searchCriteria: {
      flight: {
        departureDateOffsetInDays: startDateOffset,
        returnDepartureDateOffsetInDays: endDateOffset,
      },
    },
    minSize: minSuppliersCount,
    maxSize: maxSuppliersCount,
  };

  return <RetailFeaturedSuppliers inputs={inputs} />;
};

export const FeaturedSuppliersModule = inject("uriContext", "context")(observer(FeaturedSuppliers));

export default FeaturedSuppliersModule;
